import { render } from "./Youtube.vue?vue&type=template&id=9ecfdba4&scoped=true"
import script from "./Youtube.vue?vue&type=script&lang=js"
export * from "./Youtube.vue?vue&type=script&lang=js"

import "./Youtube.vue?vue&type=style&index=0&id=9ecfdba4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ecfdba4"]])

export default __exports__